import React from "react" 
import { useParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { CollectionLoader } from 'lib/components';

/** This a wrapper around CollectionLoader, specifically for loading Elements when they are being edited */

export default function ElementLoader({ title, clientObj, loaderFn, ...rest }: { title:string; clientObj:any; loaderFn:any; [key:string]:any }){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Elements } = queryTools.resource.parseQueryForApi("element.findAll", {}, { enabled: true })

  const prepElementsList = (templateClientObj:any) => {
    console.log(templateClientObj)
    const list = _Elements
      ?.filter(( elem:any) => elem.element_type === store.element.refstr)
      .map( (elem:any) => {
        if( templateClientObj !== undefined && templateClientObj?._id === elem.client_id ) return {...elem, name: `${elem.name} (${templateClientObj.name})`}
        if( elem.is_default === true ) return {...elem, name: `${elem.name} (default)`}
        return elem
      })
    return list
  }

  return (
    <CollectionLoader 
      title={title}
      collection={prepElementsList(clientObj)}
      selectFn={loaderFn}
      {...rest}
    />
  )
}